import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import HomePage from "./pages/HomePage";
import MasterplanPage from "./pages/MasterplanPage";
import TableAdminPage from "./pages/TableAdminPage";
import AdminLandingPage from "./pages/AdminLandingPage";
import ClientLoginPage, { isClientAuthed, getClientId, clearClientAuth } from "./pages/ClientLoginPage";
import ClientAccessPage from "./pages/ClientAccessPage";

function ClientGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const isAdmin = new URLSearchParams(window.location.search).get("admin") === "1";

  const [status, setStatus] = useState<"checking" | "ok" | "denied">(
    isAdmin ? "ok" : isClientAuthed() ? "checking" : "denied"
  );

  useEffect(() => {
    if (isAdmin) { setStatus("ok"); return; }
    if (!isClientAuthed()) { setStatus("denied"); return; }
    const clientId = getClientId();
    if (!clientId) { setStatus("denied"); return; }

    fetch("/api/client-verify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientId }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.ok) {
          setStatus("ok");
        } else {
          clearClientAuth();
          setStatus("denied");
        }
      })
      .catch(() => {
        setStatus("ok");
      });
  }, [navigate, isAdmin]);

  if (status === "denied") return <Navigate to="/" replace />;
  if (status === "checking") return null;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ClientLoginPage />} />
      <Route path="/home" element={<ClientGuard><HomePage /></ClientGuard>} />
      <Route path="/masterplan" element={<ClientGuard><MasterplanPage /></ClientGuard>} />
      <Route path="/admin" element={<AdminLandingPage />} />
      <Route path="/admin/clients" element={<ClientAccessPage />} />
      <Route path="/table-admin" element={<TableAdminPage />} />
    </Routes>
  );
}
